(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nano-fit-welcome"] && !Shopify.designMode) return;
  try {
    (() => {
if (customElements.get('nano-fit-welcome')) return;
customElements.define('nano-fit-welcome', class extends HTMLElement {
connectedCallback() {
if (this.ready) return; this.ready = true;
const dialog=this.querySelector('dialog'), form=this.querySelector('form'), input=this.querySelector('input'), submit=this.querySelector('.nf-submit'), status=this.querySelector('#nf-status'), teaser=this.querySelector('.nf-teaser');
const mode=this.dataset.mode, key='nanofit-welcome-v1', delay=30000;
const read=()=>{try{return JSON.parse(localStorage.getItem(key)||'{}')}catch{return {}}};
const write=(value)=>{try{localStorage.setItem(key,JSON.stringify({...read(),...value}))}catch{}};
const eligible=()=>!this.dataset.subscriber?.includes('true')&&!read().submitted&&!(Date.now()-Number(read().closedAt||0)<7*86400000)&&!/(^|\/)(checkout|checkouts|account|cart)(\/|$)/i.test(location.pathname);
const open=()=>{if(!dialog.open)dialog.showModal();teaser.hidden=true;};
const close=()=>{dialog.close();if(mode==='live')write({closedAt:Date.now()});teaser.hidden=Boolean(read().submitted);};
this.querySelector('.nf-close').addEventListener('click',close);
dialog.addEventListener('cancel',e=>{e.preventDefault();close()});
dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close()}});
teaser.addEventListener('click',open);
form.addEventListener('submit',async e=>{
e.preventDefault(); if(!form.reportValidity()||submit.disabled)return;
const email=input.value.trim();status.textContent='';
if(mode==='preview'){status.textContent=this.dataset.preview;return}
if(mode==='test'&&!['stu@nanofitwater.com','stevesawitz@gmail.com'].includes(email.toLowerCase())){status.textContent=this.dataset.testOnly;return}
if(!['live','test'].includes(mode))return;
submit.disabled=true;const original=submit.textContent;submit.textContent=this.dataset.sending;
try{
const response=await fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(this.dataset.company),{method:'POST',headers:{'content-type':'application/vnd.api+json','revision':'2026-07-15'},body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Nano Fit Water welcome popup',profile:{data:{type:'profile',attributes:{email,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:this.dataset.list}}}}}),signal:AbortSignal.timeout(20000)});
if(response.status!==202)throw new Error('subscription-rejected');
this.querySelector('.nf-art').hidden=true;this.querySelector('.nf-footer').hidden=true;const success=this.querySelector('.nf-success');success.hidden=false;success.focus();if(mode==='live')write({submitted:true});teaser.hidden=true;
}catch{status.textContent=this.dataset.failure}finally{submit.disabled=false;submit.textContent=original}
});
if(mode==='preview'||mode==='test'){open()}else if(mode==='live'&&eligible()){this.timer=setTimeout(()=>{if(!eligible())return;if(window.matchMedia('(max-width: 749px)').matches||location.pathname.startsWith('/products/')){teaser.hidden=false;}else if(!document.querySelector('dialog[open]')&&!document.activeElement?.matches('input,textarea,select')){open()}},delay)}
}
disconnectedCallback(){clearTimeout(this.timer)}
});
})();
  } catch(e) { console.error(e); }
})();

})();
